import React from "react";
import { useSelector } from "react-redux";
import { Card, CardActions, CardBody, CardHeader, CardTitle, StackLayout } from "@progress/kendo-react-layout";
import Badge from "./Badge";
import { Button } from '@progress/kendo-react-buttons';
import { getDateStr, getDateRangeStr } from "../utils/getDateStr";

const HTTPREGEX = new RegExp(/^https?:\/\//i);
const EMAILREGEX = new RegExp(/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i);

const styles = {
  typeBadge: {
    color: "white",
    backgroundColor: "#3f51b5",
  },
  pinnedBadge: {
    color: "white",
    backgroundColor: "green"
  },
  expiredBadge: {
    color: "white",
    backgroundColor: "#ba000d",
  },
  label: {
    paddingRight: '2px'
  },
  allDayNote: {
    paddingLeft: '6px',
    fontStyle: 'italic',
    opacity: 0.7,
  }
}

const Content = (props) => {
  const { user, token } = useSelector(state => state.authReducer);
  
  const websiteLink = (HTTPREGEX.test(props.data.website) ?
    props.data.website :
    "http://" + props.data.website);

  const emailLink = (EMAILREGEX.test(props.data.email) ?
    'mailto:' + props.data.email : 
    null);

    return props.data ? (
    <Card key={props.data.id} style={{ minWidth: '750px' }}>
      <CardHeader className="k-hbox" style={{ display: "inline" }}>
        {(props.data.site.id == user.site.id && !user.viewOnly && !user.notificationOnly) && <div style={{ display: 'inline', float: 'right' }}>
          <Button
            className="k-button k-primary k-flat"
            style={{ marginRight: "5px" }}
            onClick={() => props.update(props.data)}
            iconClass="k-icon k-i-pencil"
          />
          <Button
            className="k-button k-flat"
            onClick={() => props.delete(props.data)}
            iconClass="k-icon k-i-trash"
            style={{ color: 'red' }}
          />
        </div>}
        <CardTitle style={{ display: 'inline' }}>{props.data.title}</CardTitle>
      </CardHeader>
      <CardBody>
        {props.data.date && (props.data.objectType === 'Event' ? <p>
          <b style={styles.label}>
            When:
          </b>
          {getDateRangeStr(props.data.date, props.data.endDate, props.data.allDay)}
          {props.data.allDay && <span style={styles.allDayNote}>(all day)</span>}
        </p> : <p>
          <b style={styles.label}>
            Date:
          </b>
          {getDateStr(new Date(props.data.date))}
        </p>)}
        {props.data.details && <p>
          <b style={styles.label}>
            Details:
          </b>
          {props.data.details}
        </p>}
        {props.data.website && <b style={{ margin: '0 0 12px', display: 'block' }}>
          Website:
          <a
            target="_blank"
            href={websiteLink}
            style={{ paddingLeft: '2px' }}>
            {websiteLink}
          </a>
        </b>}
        {props.data.email && <b style={{ margin: '0 0 12px' }}>
          Email:
          <a
            target="_blank"
            href={emailLink}
            style={{ paddingLeft: '2px' }}>
            {props.data.email}
          </a>
        </b>}
        {props.data.address && <p>
          <b style={styles.label}>
            Address:
          </b>
          {props.data.address}
        </p>}
        {props.data.location && <p>
          <b style={styles.label}>
            Location:
          </b>
          {props.data.location}
        </p>}
      </CardBody>
      <CardActions style={{ display: "inline-block", marginBottom: '5px' }}>
        {
          props.data.expired && <Badge style={styles.expiredBadge} data={"Expired"}/>
        }
        {
          props.data.pinned && <Badge style={styles.pinnedBadge} data={"Pinned"}/>
        }
        <Badge style={styles.typeBadge} data={props.data.objectType} />
        {
          props.data.Groups && props.data.Groups.map((group) => {
            return <Badge data={group.name} />
          })
        }
      </CardActions>
    </Card>
  ) : null

}
export default Content;